import { useLayerStore } from '@/store/use-layer-store';
import { Shape, ShapeType } from '@/services/shape';
import { WatchfaceService } from '@/services/watchface';
import { getThenCacheRiveDirBuffer } from '@/services/compiler-refactor/pngConvert/lvglPyConvert';
import { useRuntimeStore } from '@/store/use-runtime-store';
import { ElectronApi } from '@/services/electron.api';

export const useImageRiveBufferCache = () => {
  const layerStore = useLayerStore();
  const runtimeStore = useRuntimeStore();

  const cacheWholeRiveImages = async () => {
    const riveDirs: string[] = [];
    const service = new WatchfaceService();

    const compressMethod = runtimeStore.watchfaceAst.attrsMap.compressMethod;
    const isRle = compressMethod === 'RLE' || compressMethod === 'RLEReversed';

    // 获取所有主题中所有rive的资源
    for (const theme of layerStore.themes) {
      for (const layer of theme.children) {
        const shape = Shape.getShape(layer.id);
        if (shape?.type !== ShapeType.Rive) continue;
        // 获取小核设备使用的rive资源
        const riveFile = shape.attrs.riveFile;
        if (riveFile) {
          const riveFilename = service.resource.parseFilename(riveFile);
          riveDirs.push(ElectronApi.path?.dirname(riveFilename ?? '') ?? '');
        }
      }
    }

    // 获取缓存
    for (const riveDir of riveDirs) {
      // 这里同一个目录下图片，默认format相同，且为indexed8
      await getThenCacheRiveDirBuffer({
        dir: riveDir,
        format: 'indexed8',
        isRle
      });
    }
  };

  return {
    cacheWholeRiveImages
  };
};
